export const REACTABLE_MESSAGE_TYPES = Object.freeze(['TEXT', 'IMAGE']);
export const REACTION_QUICK_FALLBACK = Object.freeze(['👍', '❤️', '😂', '😮', '😢', '🙏']);

export function isRevokedMessage(message) {
  return String(message?.status || '').toUpperCase() === 'REVOKED';
}

export function isReactableMessage(message) {
  if (!message?.serverMessageId) return false;
  if (isRevokedMessage(message)) return false;
  return REACTABLE_MESSAGE_TYPES.includes(String(message.messageType || ''));
}

export function normalizeReactionBuckets(rows, currentMemberId) {
  const mine = currentMemberId == null || currentMemberId === '' ? '' : String(currentMemberId);
  const seen = new Set();
  const out = [];
  (Array.isArray(rows) ? rows : []).forEach((row) => {
    const emoji = String(row?.emoji ?? '').trim();
    if (!emoji || seen.has(emoji)) return;
    seen.add(emoji);
    const memberIds = Array.isArray(row?.memberIds)
      ? row.memberIds.map((id) => (id == null || id === '' ? '' : String(id))).filter(Boolean)
      : [];
    let count = Number(row?.count);
    if (!Number.isFinite(count) || count < 0) {
      count = memberIds.length;
    }
    count = Math.floor(count);
    if (count <= 0) return;
    const reactedByMe = row?.reactedByMe === true
      || (mine !== '' && memberIds.some((id) => id === mine));
    out.push({ emoji, count, reactedByMe });
  });
  return out;
}

export function reactionPickerEmojis(catalog) {
  const seen = new Set();
  const out = [];
  const push = (item) => {
    const emoji = String(item?.emoji ?? item ?? '').trim();
    if (!emoji || seen.has(emoji) || item?.locked) return;
    seen.add(emoji);
    out.push(emoji);
  };
  (catalog?.quickBar || []).forEach(push);
  (catalog?.recent || []).forEach(push);
  if (!out.length) {
    REACTION_QUICK_FALLBACK.forEach((emoji) => push(emoji));
  }
  return out;
}

export function applyReactionUpdated(messages, payload, currentMemberId, conversationId) {
  const eventConversationId = payload?.conversationId == null ? '' : String(payload.conversationId);
  const serverMessageId = payload?.serverMessageId == null ? '' : String(payload.serverMessageId);
  if (!serverMessageId) return messages || [];
  if (eventConversationId && conversationId && eventConversationId !== String(conversationId)) {
    return messages || [];
  }
  const reactions = normalizeReactionBuckets(payload?.reactions, currentMemberId);
  return (messages || []).map((message) => {
    if (String(message?.serverMessageId || '') !== serverMessageId) return message;
    return { ...message, reactions };
  });
}

export function reactionMutationKey(serverMessageId, emoji) {
  return `${String(serverMessageId || '')}:${String(emoji || '')}`;
}
